import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import TextFieldObjectWithEntityListSetSimpleValueFixedStripe
    from "./TextFieldObjectWithEntityListSetSimpleValueFixedStripe";
import ButtonExit from "../../../../../button/ButtonExit";
import ButtonAdd from "../../../../../button/ButtonAdd";

const ChoiceFixedStripeModal = ({open, onClose, handleSubmit, value, setValue, entityList}) => {
    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Выбор полосы</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            gap: '1.5rem',
                        }}
                    >
                        <TextFieldObjectWithEntityListSetSimpleValueFixedStripe
                            label="Текущая полоса"
                            value={value}
                            setValue={setValue}
                            field={'stripe'}
                            entityList={entityList}
                        />
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={onClose}/>
                <ButtonAdd text={"Выбрать"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default ChoiceFixedStripeModal;